import React, { useCallback, useMemo } from 'react';
import { FacebookShareButton } from '../SocialShareButtons/FacebookShareButton';
import { TwitterShareButton } from '../SocialShareButtons/TwitterShareButton';
import { PinterestShareButton } from '../SocialShareButtons/PinterestShareButton';
import { EmailShareButton } from '../SocialShareButtons/EmailShareButton';
import { LinkShareButton } from '../SocialShareButtons/LinkShareButton';
import { ShareUrl } from '../../types/api';
import { Box, BoxProps } from '../../wag-react/next-components/box';
import { Grid } from '../../wag-react/core-components/grid';
export type ArticleShareIconsProps = Omit<BoxProps, 'value'> & Required<Pick<BoxProps, 'title'>> & {
  value: ShareUrl[];
  containerProps?: BoxProps;
};
export const ArticleShareIcons = ({
  value,
  title,
  containerProps,
  ...rest
}: ArticleShareIconsProps) => {
  const getUrl = useCallback((key: ArticleShareIconsProps['value'][0]['key']) => value.find(item => item.key === key)?.href, [value]);
  const facebookShareUrl = useMemo(() => getUrl('facebook'), [getUrl]);
  const twitterShareUrl = useMemo(() => getUrl('twitter'), [getUrl]);
  const pinterestShareUrl = useMemo(() => getUrl('pinterest'), [getUrl]);
  const emailShareUrl = useMemo(() => getUrl('email'), [getUrl]);
  const copyLinkShareUrl = useMemo(() => getUrl('copy-link'), [getUrl]);
  return <Box as="aside" position="absolute" left="-80px" top="200px" {...rest} data-sentry-element="Box" data-sentry-component="ArticleShareIcons" data-sentry-source-file="index.tsx">
      <Grid position="fixed" gridGap="16px" {...containerProps} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        <FacebookShareButton shareUrl={facebookShareUrl} data-sentry-element="FacebookShareButton" data-sentry-source-file="index.tsx" />
        <TwitterShareButton shareUrl={twitterShareUrl} text={title} data-sentry-element="TwitterShareButton" data-sentry-source-file="index.tsx" />
        <PinterestShareButton shareUrl={pinterestShareUrl} data-sentry-element="PinterestShareButton" data-sentry-source-file="index.tsx" />
        <EmailShareButton shareUrl={emailShareUrl} subject={title} data-sentry-element="EmailShareButton" data-sentry-source-file="index.tsx" />
        <LinkShareButton shareUrl={copyLinkShareUrl} data-sentry-element="LinkShareButton" data-sentry-source-file="index.tsx" />
      </Grid>
    </Box>;
};